import { MutationTree } from 'vuex';
import { MasterState } from '@/store/master/types';
import _ from 'lodash';

const mutations: MutationTree<MasterState> = {
  fetchedMasterPositions: (state, payload) => {
    state.positions = payload;
  },

  fetchedMasterUniversities: (state, payload) => {
    state.universities = payload;
  },

  fetchedMasterCampuses: (state, payload) => {
    state.campuses = payload;
  },

  fetchedMasterSemesters: (state, payload) => {
    state.semesters = payload;
  },

  fetchedMasterNationalities: (state, payload) => {
    state.nationalities = payload;
  },

  fetchedMasterTimetables: (state, payload) => {
    state.timetables = payload;
  },

  fetchedMasterTransportationExpenses: (state, payload) => {
    state.transportationExpenses = payload;
  },

  fetchedMasterHolidays: (state, payload) => {
    state.holidays = payload;
  },

  fetchedMasterLevels: (state, payload) => {
    state.levels = payload;
  },

  fetchedMasterSubjects: (state, payload) => {
    state.subjects = payload;
  },

  fetchedMasterVacationReasons: (state, payload) => {
    state.vacationReasons = payload;
  },

  fetchedMasterSpecialConsiderations: (state, payload) => {
    state.specialConsiderations = payload
  },
};

export default mutations;
